export default {"src":"/_next/static/media/add.9c8074b8.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};